import type { ContainerType } from '../../../mentions/MentionBase';
import Mention from '../../Mention';

class CommentMention extends Mention {
  protected override containerType: ContainerType = 'comment';
}

export default CommentMention;
